import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const Reports = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <Container className="mt-5 mb-5">
        <Row className="mb-4 text-center">
          <Col>
            <h2>Reports &amp; Analytics</h2>
            <p className="text-muted">Select a module to view its reports and charts</p>
          </Col>
        </Row>

        <Row className="justify-content-center g-4">
          {/* Equipment Inspection Reports */}
          <Col md={6}>
            <Card
              className="h-100 shadow text-center border-0"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/reports/inspection')}
            >
              <Card.Body className="p-5">
                <div
                  className="rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
                  style={{
                    width: 90, height: 90,
                    background: 'linear-gradient(135deg,#0d6efd,#0a58ca)'
                  }}
                >
                  <i className="fas fa-hard-hat fa-2x text-white"></i>
                </div>
                <h4 className="fw-bold mb-2">Equipment Inspection</h4>
                <p className="text-muted mb-4">
                  Monthly inspection trends, inspector utilisation, client stats,
                  certificate tracking, work order status and more.
                </p>
                <Button variant="primary" size="lg" className="px-4">
                  <i className="fas fa-chart-bar me-2"></i>View Reports
                </Button>
              </Card.Body>
              <Card.Footer className="bg-light border-0 pb-3">
                <small className="text-muted">
                  <i className="fas fa-layer-group me-1"></i>
                  Monthly · Inspector-wise · Client-wise · Equipment-wise · Work Orders
                </small>
              </Card.Footer>
            </Card>
          </Col>

        </Row>

        <Row className="mt-4 text-center">
          <Col>
            <Button variant="outline-secondary" onClick={() => navigate('/dashboard/admin')}>
              <i className="fas fa-arrow-left me-2"></i>Back to Dashboard
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Reports;
